module.exports = __webpack_public_path__ + "media/assets/ChevronUp-1e1b1d005728b30d593072c6198f46a1.svg";